import {Injectable} from '@angular/core';
import {HttpHeadersService} from "../shared/services/http-headers.service";
import {UrlConstantsService} from "../shared/services/url.constants.service";
import {Pageable} from "../shared/models/pageable";
import {Page} from "../shared/models/page";
import {Observable, Subject, throwError} from 'rxjs';
import {TestDevice} from "../models/test-device.model";
import {map} from 'rxjs/internal/operators/map';
import {catchError} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TestDeviceService {
  public formValueChanges: Subject<any> = new Subject<any>();
  constructor(
    private http: HttpClient,
    private httpHeaders: HttpHeadersService,
    private URLConstants: UrlConstantsService) {
  }

  public findAll(filter?: string, sortBy?: string, pageable?: Pageable | undefined): Observable<Page<TestDevice>> {
    return this.http.get<Page<TestDevice>>(this.URLConstants.testDevicesUrl, {
      headers: this.httpHeaders.contentTypeApplication,
      params: this.httpHeaders.serializeParams(filter, sortBy, pageable)
    }).pipe(
      map(data => new Page<TestDevice>().deserialize(data, TestDevice)),
      catchError(() => throwError('Problem while fetching Environments not found'))
    )
  }

}
